import { render, staticRenderFns } from "./dynamicDetail.vue?vue&type=template&id=d9c047da&scoped=true&"
import script from "./dynamicDetail.vue?vue&type=script&lang=js&"
export * from "./dynamicDetail.vue?vue&type=script&lang=js&"
import style0 from "./dynamicDetail.vue?vue&type=style&index=0&id=d9c047da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c047da",
  null
  
)

export default component.exports